import Layout from 'layouts/Default'
import { Button, Grid, Stack, TablePagination } from '@mui/material'
import Breadcrumbs from 'components/Breadcrumbs'
import Label from 'components/Label'
import React, { useEffect, useState } from 'react'
import {
  StyledBoxContainerContent as ContainerContent,
  StyledBoxContainerTitle as ContainerTitle,
} from './styles'
import AddRoundedIcon from '@mui/icons-material/AddRounded'
import SearchRoundedIcon from '@mui/icons-material/SearchRounded'

import { useNavigate } from 'react-router-dom'
import Input from 'components/Input'
import { useCreas } from './hook/creas.hook'
import { CreasItem } from './components/creasItem'
import creaService from 'services/crea.service'
import { useBackdrop } from 'contexts/backdrop.context'
import { useSnackBar } from 'contexts/snackbar.context'
import { SystemMessages } from 'utils/enums/system-message.enum'
import { Funcionalidades } from 'utils/helpers/funcionalidades'
import { useAuthContext } from '../../contexts/auth.context'
import DialogAlert from 'components/Dialog/Alert'
import { HttpErrorType } from '../../types/http.type'
import { errorColor, errorMessage } from 'utils/error.util'

export const SearchCreasPage = () => {
  const navigate = useNavigate()
  const { handleHasPermission } = useAuthContext()
  const {
    page,
    elements: { totalOfElements },
    creas,
    handleBuscarCreas,
    handleNewPage,
  } = useCreas()
  const { handleBackdropOpen, handleBackdropClose } = useBackdrop()
  const { showSnackBar } = useSnackBar()

  const [nome, setNome] = useState('')
  const [rowsPerPage, setRrowsPerPage] = useState(6)

  const handleDelete = async (id: number) => {
    handleBackdropOpen()
    await creaService
      .deleteById(id)
      .then(() => {
        handleBuscarCreas({ nome, page, pageSize: rowsPerPage })
        showSnackBar(SystemMessages.MESSAGE_029, 'success')
      })
      .catch((error: HttpErrorType) => {
        showSnackBar(errorMessage(error), errorColor(error))
      })
      .finally(() => handleBackdropClose())
  }

  const handleSearch = (name: string) => {
    handleBuscarCreas({ nome: name, page, pageSize: rowsPerPage })
  }

  const handlePage = async (newPage: number, newRowsPerPage?: any) => {
    handleNewPage(null, newPage)
    if (newRowsPerPage?.target?.value) {
      setRrowsPerPage(newRowsPerPage?.target?.value)
    }
    handleBuscarCreas({
      nome,
      page: newPage,
      pageSize: newRowsPerPage?.target.value || rowsPerPage,
    })
  }

  useEffect(() => {
    handleBuscarCreas({ nome, page, pageSize: rowsPerPage })
  }, [])

  return (
    <Layout>
      <Grid container spacing={2}>
        <Grid container item xs={12} sx={{ mb: 2 }}>
          <Breadcrumbs>
            <Label text='Gestão de CREAS' bold v={'body1'} />
          </Breadcrumbs>
        </Grid>
        <Grid item xs={12}>
          <ContainerTitle>
            <Label text='GESTÃO DE CREAS' v='h6' bold />
          </ContainerTitle>
          <ContainerContent>
            <Grid container spacing={2}>
              <Grid item lg={6} md={5} sm={12} xs={12} display={'flex'} direction={'column'}>
                <Input
                  value={nome}
                  onChange={(e) => setNome(e.target.value)}
                  name='name'
                  label=''
                  placeholder='Pesquisar'
                  maxLength={600}
                />
              </Grid>
              <Grid
                item
                lg={6}
                md={7}
                sm={12}
                xs={12}
                display={'flex'}
                justifyContent={'space-between'}
              >
                <Stack direction='row' spacing={2}>
                  <Button
                    variant='outlined'
                    color='secondary'
                    onClick={() => {
                      setNome('')
                      handleSearch('')
                    }}
                  >
                    Limpar
                  </Button>
                  <Button
                    variant='contained'
                    color='secondary'
                    startIcon={<SearchRoundedIcon />}
                    onClick={() => handleSearch(nome)}
                  >
                    Pesquisar
                  </Button>
                </Stack>
                {handleHasPermission(Funcionalidades.creas.cadastrar) && (
                  <Button
                    startIcon={<AddRoundedIcon />}
                    variant='contained'
                    color='primary'
                    onClick={() => navigate('/novo-creas')}
                  >
                    Cadastrar CREAS
                  </Button>
                )}
              </Grid>
            </Grid>
          </ContainerContent>
        </Grid>
        {creas.length > 0 ? (
          <>
            <Grid container item xs={12} spacing={2}>
              {creas.map((item, index) => (
                <Grid item xl={3} lg={4} md={6} sm={12} xs={12} key={index}>
                  <CreasItem creas={item} handleDelete={handleDelete} />
                </Grid>
              ))}
            </Grid>
            <Grid item xs={12}>
              <TablePagination
                labelRowsPerPage='Linhas por página: '
                labelDisplayedRows={({ from, to, count }) => {
                  return `${from}–${to} de ${count}`
                }}
                rowsPerPageOptions={[3, 6, 9, 12, 15]}
                count={totalOfElements}
                rowsPerPage={rowsPerPage}
                onPageChange={(e, p) => handlePage(p)}
                page={page}
                component='div'
                onRowsPerPageChange={(e) => handlePage(0, e)}
              />
            </Grid>
          </>
        ) : (
          <Grid item xs={12}>
            <Stack direction='row' justifyContent='center' spacing={2}>
              <Label text='Nenhum resultado encontrado...' bold />
            </Stack>
          </Grid>
        )}
      </Grid>
    </Layout>
  )
}
